<template>
  <div class="golf__filters">
    <h3>Search for Tee Times</h3>

    <!-- Calendar Date selector -->
    <div class="ax--input--container ax--input--container--weekly">
      <ax-calendar v-model="date" calendar-type="weekly" :firstAvailableDate="firstAvailableDate"></ax-calendar>
    </div>
    <!-- /Calendar Date Selector -->
    <!-- Times Stepper -->
    <div class="ax--input--container">
      <ax-label label="Times" for="teeTimes" class="golf-filter-label">
        Times
        <span v-html="timeBlockRange" />
      </ax-label>
      <ax-slider
        id="teeTimes"
        v-model="timeBlock"
        :step="10000"
        :minRange="50000"
        :maxRange="210000"
        :tooltip="false"
      ></ax-slider>
    </div>
    <!-- /Times Stepper -->
    <!-- Holes Stepper -->
    <div class="ax--input--container">
      <ax-label label="Holes" align="center" for="holes" class="golf-filter-label" />
      <ax-stepper :array-val="holesArray" :start-index="1" data-type="array" id="holes" v-model="holes"></ax-stepper>
    </div>
    <!-- /Holes Stepper -->
    <!-- Players Stepper -->
    <div class="ax--input--container">
      <ax-label label="Players" align="center" for="players" class="golf-filter-label"/>
      <ax-stepper :array-val="playersArray" data-type="array" id="players" v-model="players"></ax-stepper>
    </div>
    <!-- /Players Stepper -->
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'ProductFilters-golf',

  props: {
    productSkus: {
      type: Array,
      default: null,
    },
    value: {
      type: [String, Number, Object],
      default: null,
    },
  },

  model: {
    event: 'filter-changed',
  },

  filters: {
    formattedTime(n) {
      const time = n.toString()
      const seconds = time.substring(time.length - 2, time.length)
      const minute = time.substring(time.length - 4, time.length - 2)
      const hour = time.substring(0, time.length - 4)
      const formattedHour = hour > 12 ? hour - 12 : hour
      const amPm = hour > 11 ? 'pm' : 'am'
      return `${formattedHour}:${minute}${amPm}`
    },
  },

  data() {
    return {
      holesArray: [
        {
          label: '9',
          value: 9,
        },
        {
          label: '18',
          value: 18,
        },
      ],
      playersArray: [
        {
          label: 'any',
          value: 'any',
        },
        {
          label: '1',
          value: 1,
        },
        {
          label: '2',
          value: 2,
        },
        {
          label: '3',
          value: 3,
        },
        {
          label: '4',
          value: 4,
        },
      ],
    }
  },
  mounted() {
    this.fetchFirstAvailableDate()
  },
  methods: {
    fetchFirstAvailableDate() {
      axios
        .get(`/api/golf/teetimes/earliestavailable?courseIds=${this.courseIds}&numberOfHoles=${this.holes}`)
        .then((result) => {
          this.firstAvailableDate = result.data
        })
        .catch((e) => {
          return null
        })
    },
  },
  computed: {
    courseIds() {
      return this.productSkus ? this.productSkus.join(',') : ''
    },
    date: {
      get() {
        return this.$store.state.filters.date
      },
      set(n) {
        this.$store.commit('filters/date', n)
      },
    },
    firstAvailableDate: {
      get() {
        return this.$store.state.filters.firstAvailableDate
      },
      set(n) {
        this.$store.commit('filters/firstAvailableDate', n)
      },
    },
    holes: {
      get() {
        return this.$store.state.filters.holes
      },
      set(n) {
        this.$store.commit('filters/holes', n)
      },
    },
    timeBlock: {
      get() {
        return this.$store.state.filters.timeBlock
      },
      set(n) {
        this.$store.commit('filters/timeBlock', n)
      },
    },
    players: {
      get() {
        return this.$store.state.filters.players
      },
      set(n) {
        this.$store.commit('filters/players', n)
      },
    },
    timeBlockRange() {
      return `${this.$options.filters.formattedTime(this.timeBlock.minValue)} - ${this.$options.filters.formattedTime(
        this.timeBlock.maxValue
      )}`
    },
  },
}
</script>

<style>
.ax--label.golf-filter-label {
  font-family: var(--ads-headings-fontfamily);
  color: var(--ads-headings-color) !important;
  font-weight: bold;
}
</style>